var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"container",class:{fluid: _vm.fluid, 'q-px-xs-sm q-px-sm-md q-px-md-xl q-px-lg-xl': !_vm.fluid}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }